import "./account.css"
import acc_logo from "../../../assets/logo.svg"
import acc_landing_logo from "../../../assets/account_landing_logo.png"
import React, {useEffect, useState} from "react";
import {Link} from "react-router-dom";
import {setAccountType, setSelectedLabel, setSelectedOption} from '../../../redux/account_store';
import {setPersonalData} from "../../../redux/personal_store";
import {connect} from 'react-redux';
import {useTranslation} from "react-i18next";
import Logout from "../../logout/Logout";

function AccountInfo({
                         accountType,
                         setAccountType,
                         selectedOption,
                         setSelectedOption,
                         setSelectedLabel,
                         appData,
                         financialInfo,
                         personalData
                     }) {

    const [isCashError, setIsCashError] = useState(false);

    let backTo = '/affiliation'
    if (appData.account_type === 'custodial') backTo = '/custodial-account'
    if (appData.account_type === 'speciality') backTo = '/authorized-signers'

    const {t} = useTranslation()

    const handleAccountChange = (newAccountType) => {
        if (appData.hear_about_us === "DAWUL") {
            return;
        }

        if (financialInfo.assets === 'A') {
            if (newAccountType === 'marginAcc') {
                setIsCashError(true)
            } else {
                setIsCashError(false)
                setAccountType(newAccountType);
            }
        } else {
            setIsCashError(false)
            setAccountType(newAccountType);
        }
    };

    useEffect(() => {
        if (appData.account_type === "custodial") {
            setAccountType("cashAcc");
            setSelectedOption("level2");
            setSelectedLabel("level2");
        }

        if(appData.hear_about_us === "DAWUL"){
            setAccountType("marginAcc");
            setSelectedOption("level4");
            setSelectedLabel("level4");
        }
    }, [appData.account_type, appData.hear_about_us, setAccountType, setSelectedOption, setSelectedLabel]);

    const handleRadioChange = (option) => {
        if (appData.hear_about_us === "DAWUL") {
            return;
        }

        setSelectedOption(option);
        setSelectedLabel(option);
    };

    return (
        <div className="account">
            <div className="account_left_side">
                <img src={acc_logo} alt=""/>
                <img style={{paddingTop: "12%"}} src={acc_landing_logo} alt=""/>
            </div>
            <div className="account_right_side">
                <div className="account_info">
                    <Logout/>
                    <p className="account_text">{t('account.welcome')} {personalData.firstName} {personalData.lastName}. {t('account.option_trading')}</p>
                    <p className="account_privileges">{t('account.account_privileges')}</p>
                    <p className="account_profile">{t('account.account_profile')}</p>
                    <div className="account_checkbox">
                        {appData.account_type !== "custodial" && (
                            <div className="checks">
                                <input
                                    type="radio"
                                    className="account_check"
                                    name="accountType"
                                    onChange={() => handleAccountChange('marginAcc')}
                                    checked={accountType === 'marginAcc'}
                                />
                                <label className="account_check_label">{t('account.cash_margin')}</label>
                            </div>
                        )}

                        <div className="checks">
                            <input
                                type="radio"
                                className="account_check"
                                name="accountType"
                                onChange={() => handleAccountChange('cashAcc')}
                                checked={accountType === 'cashAcc'}
                            />
                            <label className="account_check_label">{t('account.cash')}</label>
                        </div>
                    </div>
                    <div>
                        {
                            isCashError &&
                            <p style={{color: "red", textAlign: "center"}}>{t('errors.liquid_error')}</p>
                        }
                    </div>

                    <p className="account_cash_text">{t('account.cash_margin_accounts')}</p>

                    <p className="specific_account">{t('account.specify_trading_level')}</p>
                    <p className="specific_account_text">{t('account.option_trading_level')}</p>
                    <p className="choose_account">{t('account.choose_one')}</p>
                    <div className="specific_account_checkbox">
                        <div className="checks">
                            <input type="radio" className="account_check"
                                   onChange={() => handleRadioChange("level1")}
                                   checked={selectedOption === "level1"}
                            />
                            <label className="account_check_label">{t('account.level1')}</label>
                        </div>
                        <div className="checks">
                            <input type="radio" className="account_check"
                                   checked={selectedOption === "level2"}
                                   onChange={() => handleRadioChange("level2")}
                            />
                            <label className="account_check_label">{t('account.level2')}</label>
                        </div>
                        <div className="checks">
                            <input type="radio" className="account_check"
                                   onChange={() => handleRadioChange("level3")}
                                   checked={selectedOption === "level3"}
                            />
                            <label className="account_check_label">{t('account.level3')}</label>
                        </div>
                        <div className="checks">
                            <input type="radio"
                                   className="account_check"
                                   onChange={() => handleRadioChange("level4")}
                                   checked={selectedOption === "level4"}
                            />
                            <label className="account_check_label">{t('account.level4')}</label>
                        </div>
                        <div className="checks">
                            <input type="radio" className="account_check"
                                   disabled={true}
                                   onChange={() => handleRadioChange("level5")}
                                   checked={selectedOption === "level5"}
                            />
                            <label className="account_check_label">{t('account.level5')}</label>
                        </div>
                        <div className="checks">
                            <input type="radio" className="account_check"
                                   onChange={() => handleRadioChange("level0")}
                                   checked={selectedOption === "level0"}
                            />
                            <label className="account_check_label">{t('account.level6')}</label>
                        </div>
                    </div>

                </div>
                <div className="account_btn">
                    <Link style={{textDecoration: "none"}} to={backTo}>
                        <button className="account_back_btn">{t('back_btn')}</button>
                    </Link>
                    <Link to="/experience" style={{textDecoration: "none"}}>
                        <button className="account_continue_btn" type="submit">{t('next_btn')}</button>
                    </Link>
                </div>
            </div>
        </div>
    )
}

const mapStateToProps = (state) => ({
    accountType: state.account.accountType,
    selectedOption: state.account.selectedOption,
    selectedLabel: state.account.selectedLabel,
    appData: state.appData,
    personalData: state.personalData,
    financialInfo: state.financialInfo
});

const mapDispatchToProps = {
    setAccountType,
    setSelectedOption,
    setSelectedLabel,
    setPersonalData
};

export default connect(mapStateToProps, mapDispatchToProps)(AccountInfo);